<template>
    <a-col>
        <slot name="title"></slot>
        <slot name="subTitle"></slot>
    </a-col>
</template>

<script>
    export default {
        name: 'ProvisioningTitle',      
    }
</script>